// extracted by mini-css-extract-plugin
export default {"controls":"header-component_controls__pgyto","addButton":"header-component_addButton__6yqd2","title":"header-component_title__r52lR"};